export const isNotEmptyInput = (value: string): boolean => {
  return value.trim().length > 0
}

export const requiredMessage = 'Обязательное поле'
